import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 28L21.4 26.6L15.8 21L28 21L28 19L15.8 19L21.4 13.4L20 12L12 20L20 28Z", fill: "#0B4566" }));
export default SvgArrowLeft;
